export enum ProductAITabValue {
  Prompt = 0,
  Template,
  Enhance,
  Validate,
  History,
  Normalization,
}
